// 10 Farklı Detaylı Kurumsal ERP / CRM Modül Sayfası Mock Verileri

export const crmCustomersData = {
  title: "Müşteri Kartları",
  breadcrumb: "Anasayfa → Cari Hesaplar → Müşteri Kartları",
  summary: {
    totalCustomers: 128,
    totalReceivable: "₺2.480.000",
    avgMaturity: "32 gün",
    collectionScore: "%94.6",
  },
  filters: ["Tümü (128)", "Kurumsal (86)", "VIP Müşteri (14)", "Risk İzleme (4)"],
  customers: [
    {
      id: "C-101",
      name: "Anadolu Makine Sanayi A.Ş.",
      city: "Kayseri OSB",
      sector: "Ağır Sanayi",
      balance: "₺420.000",
      creditLimit: "₺1.000.000",
      limitPercent: 42,
      score: "A+",
      contact: "Ahmet Yılmaz (Genel Md.)",
      phone: "0352 321 44**",
      status: "Onaylı Cari",
    },
    {
      id: "C-142",
      name: "Ege Entegre Lojistik A.Ş.",
      city: "İzmir / Kemalpaşa",
      sector: "Lojistik / Taşımacılık",
      balance: "₺680.000",
      creditLimit: "₺800.000",
      limitPercent: 85,
      score: "B+",
      contact: "Cemile Demir (Satınalma)",
      phone: "0232 441 22**",
      status: "Limit Takibinde",
    },
    {
      id: "C-208",
      name: "Başak Traktör & Ziraat Teknolojileri",
      city: "Sakarya / Adapazarı",
      sector: "Otomotiv / Tarım",
      balance: "₺195.000",
      creditLimit: "₺1.500.000",
      limitPercent: 13,
      score: "AAA",
      contact: "Kemal Koç (Finans Md.)",
      phone: "0264 277 88**",
      status: "Onaylı Cari",
    },
    {
      id: "C-311",
      name: "Marmara Çelik & Metal Yapı Ltd.",
      city: "Kocaeli / Gebze",
      sector: "Metalurji",
      balance: "₺890.000",
      creditLimit: "₺900.000",
      limitPercent: 98,
      score: "C-",
      contact: "Orhan Tunç (Mali İşler)",
      phone: "0262 648 11**",
      status: "Risk Limiti Doldu",
    },
  ],
};

export const crmOppsData = {
  title: "Satış Fırsatları (Pipeline)",
  breadcrumb: "Anasayfa → Satış → Satış Fırsatları",
  summary: {
    pipelineTotal: "₺2.840.000",
    openDeals: 14,
    avgWinRate: "%68",
    cycleDays: "14 gün",
  },
  columns: [
    {
      id: "stage-qualify",
      title: "Nitelikli Talep & Keşif",
      total: "₺480.000",
      count: 2,
      deals: [
        {
          id: "opp-1",
          company: "Borusan Otomotiv",
          project: "Filo ERP & Telemetri",
          amount: "₺320.000",
          probability: 60,
          contact: "Burak Arıcan",
          daysLeft: "3 gün",
          tag: "Sıcak",
        },
        {
          id: "opp-2",
          company: "Asel Makine Sanayi",
          project: "WMS Depo Barkod Otomasyonu",
          amount: "₺160.000",
          probability: 50,
          contact: "Mehmet Çiftçi",
          daysLeft: "7 gün",
          tag: "Yeni",
        },
      ],
    },
    {
      id: "stage-proposal",
      title: "Teklif & Demo Sunuldu",
      total: "₺890.000",
      count: 2,
      deals: [
        {
          id: "opp-3",
          company: "Yıldız Holding Grup",
          project: "Fabrika Üretim Planlama (MRP)",
          amount: "₺650.000",
          probability: 75,
          contact: "Selin Yıldız",
          daysLeft: "2 gün",
          tag: "Karar Aşamasında",
        },
        {
          id: "opp-4",
          company: "Tekno Lojistik A.Ş.",
          project: "B2B Bayi Sipariş Portalı",
          amount: "₺240.000",
          probability: 80,
          contact: "Hakan Güler",
          daysLeft: "5 gün",
          tag: "Revize Teklif",
        },
      ],
    },
    {
      id: "stage-closing",
      title: "Sözleşme & Kapanış",
      total: "₺1.470.000",
      count: 2,
      deals: [
        {
          id: "opp-5",
          company: "Başak Traktör",
          project: "Kurumsal ERP Entegrasyon Lisansı",
          amount: "₺950.000",
          probability: 95,
          contact: "Kemal Koç",
          daysLeft: "24 saat",
          tag: "İmzaya Hazır",
        },
        {
          id: "opp-6",
          company: "Ege Entegre",
          project: "e-Dönüşüm & Konsolide Finans",
          amount: "₺520.000",
          probability: 90,
          contact: "Cemile Demir",
          daysLeft: "48 saat",
          tag: "Avans Bekleniyor",
        },
      ],
    },
  ],
};

export const crmItemsData = {
  title: "Stok Kartları & Envanter",
  breadcrumb: "Anasayfa → Stok → Stok Kartları",
  summary: {
    totalSkus: "1.420 SKU",
    warehouseCap: "%84",
    criticalItems: 6,
    turnoverRate: "4.2x",
  },
  warehouseName: "Merkez Depo (A Blok)",
  items: [
    {
      sku: "SK-010",
      barcode: "8690124881021",
      name: "Rulman 6204-2RS Endüstriyel",
      category: "Mekanik Aksam",
      location: "Raf A-14 / Göz 02",
      currentStock: 1240,
      minStock: 200,
      stockPercent: 92,
      reserved: "160 ad.",
      unitPrice: "₺45,00",
      salePrice: "₺78,50",
      status: "Yeterli",
    },
    {
      sku: "SK-142",
      barcode: "8690124881428",
      name: "Hidrolik Valf Gövdesi 3/4\"",
      category: "Hidrolik & Pnömatik",
      location: "Raf B-08 / Göz 04",
      currentStock: 45,
      minStock: 60,
      stockPercent: 32,
      reserved: "30 ad.",
      unitPrice: "₺380,00",
      salePrice: "₺620,00",
      status: "Kritik Seviye",
    },
    {
      sku: "SK-880",
      barcode: "8690124888809",
      name: "Alüminyum Profil 40x40 Eloksal",
      category: "Hammadde / Metal",
      location: "Depo Dış Saha / Bölüm C",
      currentStock: 380,
      minStock: 150,
      stockPercent: 78,
      reserved: "80 mt.",
      unitPrice: "₺110,00",
      salePrice: "₺185,00",
      status: "Normal",
    },
    {
      sku: "SK-921",
      barcode: "8690124889219",
      name: "Endüstriyel Optik Sensör V2",
      category: "Elektrik & Otomasyon",
      location: "Raf E-02 / Göz 11",
      currentStock: 160,
      minStock: 50,
      stockPercent: 88,
      reserved: "24 ad.",
      unitPrice: "₺540,00",
      salePrice: "₺920,00",
      status: "Yeterli",
    },
  ],
};

export const crmBomData = {
  title: "Ürün Reçeteleri (BOM)",
  breadcrumb: "Anasayfa → Üretim → Ürün Reçeteleri",
  product: {
    name: "Endüstriyel Güç Ünitesi 24V 500W",
    code: "BOM-2026-X8",
    version: "v2.4 (Aktif Üretim)",
    unitCost: "₺1.056,00",
    laborTime: "45 dk.",
    approvedBy: "Müh. Selçuk Kurt",
  },
  components: [
    {
      code: "BOM-C1",
      name: "Elektrostatik Çelik Kasa Şasisi",
      type: "Yarı Mamul",
      qty: "1 adet",
      waste: "%0.5",
      unitCost: "₺280,00",
      totalCost: "₺280,00",
      operation: "Lazer Kesim & Büküm",
    },
    {
      code: "BOM-C2",
      name: "Bakır Sargılı Toroid Trafo 500W",
      type: "Satınalma Parça",
      qty: "1 adet",
      waste: "%0.0",
      unitCost: "₺450,00",
      totalCost: "₺450,00",
      operation: "Mekanik Montaj",
    },
    {
      code: "BOM-C3",
      name: "Regülatör Güç Kartı PCB V3",
      type: "Elektronik Kart",
      qty: "2 adet",
      waste: "%1.0",
      unitCost: "₺155,00",
      totalCost: "₺310,00",
      operation: "SMD Dizgi & Test",
    },
    {
      code: "BOM-C4",
      name: "Paslanmaz Civata & Somun Seti M4",
      type: "Bağlantı Parçası",
      qty: "16 adet",
      waste: "%2.0",
      unitCost: "₺1,00",
      totalCost: "₺16,00",
      operation: "Gövde Kapatma",
    },
  ],
  operations: [
    { step: "Op 10", name: "Kasa Montajı", time: "15 dk", machine: "İstasyon A1" },
    { step: "Op 20", name: "Trafo & PCB Bağlantısı", time: "20 dk", machine: "İstasyon B3" },
    { step: "Op 30", name: "Yüksek Gerilim & Kalibrasyon", time: "10 dk", machine: "Test Kabini 2" },
  ],
};

export const crmJobsData = {
  title: "İş Emirleri & Üretim Takip",
  breadcrumb: "Anasayfa → Üretim → İş Emirleri",
  summary: {
    activeWorkOrders: 6,
    dailyCompleted: "%78",
    capacityLoad: "%89",
    scrapRate: "%1.2",
  },
  shift: "Gündüz Vardiyası (08:00 - 17:30)",
  orders: [
    {
      id: "IE-2026-077",
      product: "Endüstriyel Güç Ünitesi 24V",
      line: "Hat 1 · Montaj İstasyonu",
      targetQty: 50,
      completedQty: 38,
      percent: 76,
      operator: "Mehmet Demir (Kıdemli)",
      duration: "08:30 - 16:00",
      status: "Hatta / Devam Ediyor",
    },
    {
      id: "IE-2026-082",
      product: "Şanzıman Döküm Gövde CNC",
      line: "Hat 3 · 5 Eksen CNC Freze",
      targetQty: 60,
      completedQty: 60,
      percent: 100,
      operator: "Ali Can (CNC Operatörü)",
      duration: "Tamamlandı",
      status: "Kalite Onayında",
    },
    {
      id: "IE-2026-090",
      product: "Otomasyon Panosu T4 Seri",
      line: "Hat 2 · Pano Kablaj",
      targetQty: 10,
      completedQty: 4,
      percent: 40,
      operator: "Serdar Aktaş",
      duration: "10:00 - 17:00",
      status: "Hatta / Devam Ediyor",
    },
    {
      id: "IE-2026-094",
      product: "Ağır Tip Destek Şasisi Kaynak",
      line: "Kaynak İstasyonu K2",
      targetQty: 15,
      completedQty: 0,
      percent: 0,
      operator: "Hasan Uçar",
      duration: "Sıradaki İş",
      status: "Hammadde Bekleniyor",
    },
  ],
};

export const crmPurchaseData = {
  title: "Satınalma Talepleri",
  breadcrumb: "Anasayfa → Satın Alma → Satınalma Talepleri",
  summary: {
    pendingApproval: 4,
    approvedThisMonth: "₺640.000",
    activeSuppliers: 34,
    onTimeDelivery: "%96.4",
  },
  requests: [
    {
      id: "TAL-2026-441",
      dept: "Üretim / Montaj Hattı",
      requester: "Murat Şahin (Usta Başı)",
      itemsSummary: "Pnömatik Valf Seti & Rulman (4 Kalem)",
      estAmount: "₺48.500",
      preferredSupplier: "Schneider / Norm Cıvata",
      urgency: "Yüksek",
      steps: [
        { label: "Departman", state: "done" },
        { label: "Satınalma", state: "done" },
        { label: "Finans Onayı", state: "active" },
      ],
      status: "Finans Direktörü Onayında",
    },
    {
      id: "TAL-2026-448",
      dept: "Döküm Atölyesi",
      requester: "İbrahim Kılıç (Mühendis)",
      itemsSummary: "Pik Döküm Gövde Bloğu GG-25 (40 Blok)",
      estAmount: "₺185.000",
      preferredSupplier: "Erkunt Döküm A.Ş.",
      urgency: "Normal",
      steps: [
        { label: "Departman", state: "done" },
        { label: "Satınalma", state: "active" },
        { label: "Finans Onayı", state: "wait" },
      ],
      status: "Teklif Toplanıyor",
    },
    {
      id: "TAL-2026-452",
      dept: "Elektrik & Pano",
      requester: "Mustafa Çelik",
      itemsSummary: "Kontaktör & Termik Röle (85 Kalem)",
      estAmount: "₺72.000",
      preferredSupplier: "ABB Elektrik Sanayi",
      urgency: "Acil",
      steps: [
        { label: "Departman", state: "done" },
        { label: "Satınalma", state: "done" },
        { label: "Finans Onayı", state: "done" },
      ],
      status: "Sipariş Verildi",
    },
    {
      id: "TAL-2026-459",
      dept: "Bakım Onarım",
      requester: "Kemal Demir",
      itemsSummary: "Hidrolik Hortum R2 Çift Örgü (120 mt)",
      estAmount: "₺28.400",
      preferredSupplier: "Pirelli Hortum",
      urgency: "Normal",
      steps: [
        { label: "Departman", state: "active" },
        { label: "Satınalma", state: "wait" },
        { label: "Finans Onayı", state: "wait" },
      ],
      status: "Bölüm Müdürü İncelemesinde",
    },
  ],
};

export const crmCashData = {
  title: "Kasa & Banka Yönetimi",
  breadcrumb: "Anasayfa → Finans → Kasa & Banka",
  summary: {
    totalLiquidity: "₺2.611.400",
    dailyInflow: "+₺340.000",
    dailyOutflow: "-₺110.000",
    netCashDelta: "+₺230.000",
  },
  accounts: [
    {
      id: "acc-tl",
      name: "Merkez TL Kasa",
      type: "Nakit Kasa",
      currency: "TRY",
      balance: "₺842.500",
      todayChange: "+₺64.000",
      up: true,
    },
    {
      id: "acc-gb",
      name: "Garanti BBVA Ticari TL",
      type: "Banka Mevduat",
      currency: "TRY",
      balance: "₺1.450.000",
      todayChange: "+₺210.000",
      up: true,
    },
    {
      id: "acc-usd",
      name: "İş Bankası Döviz USD",
      type: "Döviz Hesabı",
      currency: "USD",
      balance: "$64.200",
      todayChange: "+$12.500",
      up: true,
    },
    {
      id: "acc-pos",
      name: "E-Ticaret Sanal POS",
      type: "Havuz Hesap",
      currency: "TRY",
      balance: "₺318.900",
      todayChange: "+₺62.400",
      up: true,
    },
  ],
  transactions: [
    {
      id: "TRX-9941",
      time: "10:15",
      account: "Garanti BBVA Ticari",
      party: "Anadolu Makine Sanayi",
      desc: "Fatura Hakediş Tahsilatı (GIB-091)",
      amount: "+₺210.000",
      isIncome: true,
      docNo: "DEK-4401",
    },
    {
      id: "TRX-9942",
      time: "09:40",
      account: "Merkez TL Kasa",
      party: "Norm Cıvata Sanayi",
      desc: "Hammadde Peşin Ödemesi",
      amount: "-₺48.500",
      isIncome: false,
      docNo: "KAS-8812",
    },
    {
      id: "TRX-9943",
      time: "09:10",
      account: "İş Bankası Döviz USD",
      party: "Borusan Enerji Export",
      desc: "İhracat Konsinye Transferi",
      amount: "+$12.500",
      isIncome: true,
      docNo: "SWIFT-902",
    },
    {
      id: "TRX-9944",
      time: "08:45",
      account: "E-Ticaret Sanal POS",
      party: "B2B Bayi Portalı Gün Sonu",
      desc: "Otomatik Havuz Virmanı",
      amount: "+₺62.400",
      isIncome: true,
      docNo: "POS-003",
    },
  ],
};

export const crmEbillsData = {
  title: "e-Fatura / e-Arşiv Portalı",
  breadcrumb: "Anasayfa → Finans → e-Fatura / e-Arşiv",
  summary: {
    gibStatus: "GİB Servisi Çevrimiçi ●",
    remainingCredits: "14.850 Kontör",
    sentThisMonth: "42 Fatura",
    totalTurnover: "₺1.840.000",
  },
  bills: [
    {
      id: "GIB202600000142",
      ettn: "4a8f19e0-84c1-4f9e-a021-998273b4012a",
      company: "Ege Entegre Lojistik A.Ş.",
      vkn: "3250489912",
      type: "e-Fatura",
      scenario: "Ticari Fatura",
      subtotal: "₺210.000",
      vat: "₺42.000",
      total: "₺252.000",
      date: "10.09.2026",
      gibStatus: "1200 - Başarıyla Tamamlandı",
      gibCode: "ok",
    },
    {
      id: "GIB202600000143",
      ettn: "8c3109a1-55db-410a-b328-1100984df552",
      company: "Atlas Kimya & Plastik San. Ltd.",
      vkn: "1180293844",
      type: "e-Arşiv",
      scenario: "Standart Satış",
      subtotal: "₺48.500",
      vat: "₺9.700",
      total: "₺58.200",
      date: "09.09.2026",
      gibStatus: "1200 - Başarıyla Tamamlandı",
      gibCode: "ok",
    },
    {
      id: "GIB202600000144",
      ettn: "f21b77a0-0012-4aa8-9f20-8812739bb001",
      company: "Borusan Enerji Dağıtım A.Ş.",
      vkn: "1820491823",
      type: "e-Fatura",
      scenario: "Tevkifatlı Satış",
      subtotal: "₺385.000",
      vat: "₺38.500",
      total: "₺423.500",
      date: "09.09.2026",
      gibStatus: "1150 - GİB Kuyruğunda İşleniyor",
      gibCode: "queue",
    },
    {
      id: "GIB202600000145",
      ettn: "e3914a82-140a-4089-a221-7718290cc332",
      company: "Örnek Makine Kalıp Sanayi",
      vkn: "6620194821",
      type: "e-Fatura",
      scenario: "İhracat Faturası",
      subtotal: "₺72.000",
      vat: "₺0 (İstisna)",
      total: "₺72.000",
      date: "08.09.2026",
      gibStatus: "1200 - Başarıyla Tamamlandı",
      gibCode: "ok",
    },
  ],
};

export const crmTicketsData = {
  title: "Servis & Destek Talepleri",
  breadcrumb: "Anasayfa → Destek / Servis → Servis Talepleri",
  summary: {
    openTickets: 9,
    slaCompliance: "%94.2",
    avgFirstResponse: "18 dk.",
    satisfactionScore: "4.9 / 5.0",
  },
  tickets: [
    {
      id: "#SRV-1044",
      client: "Borusan Otomotiv",
      subject: "Sanal POS Callback Zaman Aşımı ve Token Yenileme",
      priority: "Kritik (P1)",
      priorityCode: "p1",
      slaTime: "1 sa. 12 dk kaldı",
      slaSafe: true,
      assignee: "Serkan Kaya (Kıdemli Mimar)",
      status: "İnceleniyor",
      statusCode: "progress",
    },
    {
      id: "#SRV-1049",
      client: "Tekno Lojistik A.Ş.",
      subject: "Depo El Terminali Barkod Okuyucu Driver Güncellemesi",
      priority: "Yüksek (P2)",
      priorityCode: "p2",
      slaTime: "3 sa. 45 dk kaldı",
      slaSafe: true,
      assignee: "Gamze Yıldırım",
      status: "Müşteri Yanıtı Bekleniyor",
      statusCode: "wait",
    },
    {
      id: "#SRV-1052",
      client: "Anadolu Makine Sanayi",
      subject: "Cari Yaşlandırma Raporu Excel Dışa Aktarımı",
      priority: "Normal (P3)",
      priorityCode: "p3",
      slaTime: "Zamanında Çözüldü ✓",
      slaSafe: true,
      assignee: "Deniz Arda",
      status: "Çözüldü",
      statusCode: "done",
    },
    {
      id: "#SRV-1058",
      client: "Başak Traktör",
      subject: "Üretim Reçetesi (BOM) Çoklu Revizyon Yetkilendirme",
      priority: "Normal (P3)",
      priorityCode: "p3",
      slaTime: "Zamanında Çözüldü ✓",
      slaSafe: true,
      assignee: "Gamze Yıldırım",
      status: "Çözüldü",
      statusCode: "done",
    },
  ],
};
